import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyLoad = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`, readItems: { searchTerm: ' ' } })
            .then((result) => {
                console.log('>>>>', result.data.data)
                let loadtypeRes = result.data.data

                if (localStorage.getItem('customerNumber') == 549) {
                    loadtypeRes.forEach(element => {
                        if (element.load_type_name == "Frozen") {
                            element.load_type_name = 'Reefer'
                        }
                    });
                    let newLoadType = loadtypeRes.filter((type) => {
                        if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
                            return type
                        }
                    })

                    setcontent(newLoadType)
                }
                else {
                    setcontent(loadtypeRes)
                }

                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.load_type_id
            temp.text = object.load_type_name
            temp.value = object.load_type_id
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyLoad